import { AutocompleteValue } from '@freighthub/silhouette-core'
import { HttpBaseApiWrapper } from 'service/HttpBaseApiWrapper'

import { IAddressJSON, TAddress } from '../domain/AddressModel'
import { get, IApiService, IApiServiceProps, TGet } from './ApiService'
import { autocomplete, IAutocompleteService, TAutocomplete } from './AutocompleteService'

export interface IAddressAutocompleteJSON {
  _id?: string
  place_id: string
  description: string
}

export class AddressService implements IApiService, IAutocompleteService<IAddressAutocompleteJSON[]> {
  endpoint = 'places'
  autocompleteEndpoint = 'places/search'
  // @ts-expect-error TS(2564) FIXME: Property 'httpAPI' has no initializer and is not d... Remove this comment to see the full error message
  httpAPI: HttpBaseApiWrapper
  // @ts-expect-error TS(2564) FIXME: Property 'get' has no initializer and is not defin... Remove this comment to see the full error message
  get: TGet<IAddressJSON>
  // @ts-expect-error TS(2564) FIXME: Property 'autocomplete' has no initializer and is ... Remove this comment to see the full error message
  autocomplete: TAutocomplete<IAddressAutocompleteJSON[]>
  constructor(props: IApiServiceProps) {
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    Object.assign(this, props, { autocomplete: autocomplete.bind(this), get })
  }
  autocompleteProcess = (addresses: IAddressAutocompleteJSON[]): Array<AutocompleteValue> => {
    return addresses.slice(0, 5).map((place) => {
      return {
        value: place,
        text: `🚪  ${place.description}`,
      }
    })
  }
  transformGooglePlaceToAddress(address: IAddressAutocompleteJSON): Promise<IAddressJSON> {
    return this.get(address.place_id)
  }
  autocompleteSelect(model: TAddress, address: IAddressAutocompleteJSON): Promise<TAddress> {
    return this.transformGooglePlaceToAddress(address).then((addressJSON) => {
      model.fromJSON(addressJSON)
      return model
    })
  }

  applySnapshot(model: TAddress, address: IAddressJSON) {
    model.fromJSON(address)
  }
}
